import * as yup from 'yup';
import { validateObject, validateObject2 } from '../functions';
import { opcoesMulti } from './objectSelect';



export const validationForm = yup.object().shape({
    name: yup.string().max(80, 'a quantidade maxima de caracteres são 80').required('informe o nome da escola, este campo é obrigatório'),
    typeMediation: yup.number().moreThan(0, 'Selecione uma opção').typeError(' Selecione uma das opções'),
    typeServices: yup.object({
        curricularStage: yup.number().nullable(),
        complementaryActivity: yup.number().nullable(),
        specializedEducationalService: yup.number().nullable(),
    }).nullable().test('at-least-one-attribute', 'Selecione pelo menos uma opção', value => {
        if (!value || typeof value !== 'object') return false;
        return Object.values(value).some(v => v !== null && v !== undefined && v !== 0);
    }),
    daysWeek: yup.object({
        sunday: yup.string().nullable(),
        monday: yup.string().nullable(),
        tuesday: yup.string().nullable(),
        wednesday: yup.string().nullable(),
        thursday: yup.string().nullable(),
        friday: yup.string().nullable(),
        saturday: yup.string().nullable(),
    }).nullable()
        .test('required-if-typeMediation-1', 'Selecione pelo menos um dia da semana preenchido', function (value) {
            const { typeMediation } = this.parent;
            if (Number(typeMediation) !== 1) return true;

            const hasAtLeastOne = Object.values(value || {}).some(v => typeof v === 'string' && v.trim() !== '');
            return hasAtLeastOne;
        }),
    workingPlace: yup.number().when('typeMediation', {
        is: (value) => {
            if (value !== null) {
                if (Number(value) === 1 || Number(value) === 2) {
                        return true;
                    }
            }
            return false;
        },
        then: yup.number().moreThan(-1, ' Selecione pelo menos umad opção').typeError(' Selecione pelo menos uma opção'),
    }).nullable(),

    specialEducationClass: yup.number().when('typeServices', {
        is: (typeServices) => {
            if (typeServices?.curricularStage === 1) {
                return true;
            }
            return false;
        },
        then: yup.number().moreThan(-1, ' Selecione pelo menos umad opção').typeError(' Selecione pelo menos uma opção'),
    }).nullable(),
    aggregateStage: yup.number().when('typeServices', {
        is: (typeServices) => {
            if (typeServices?.curricularStage === 1) {
                return true;
            }
            return false;
        },
        then: yup.number().moreThan(0, ' Selecione pelo menos umad opção').typeError(' Selecione pelo menos uma opção'),
    }).nullable(),
    curricularOrganization: yup
        .object({
            basicGeneralFormation: yup.number().nullable(),
            deepFormativeItinerary: yup.number().nullable(),
            professionalFormativeItinerary: yup.number().nullable(),
        })
        .nullable()
        .test('at-least-one-valid', 'Selecione pelo menos uma opção', function(value) {
            const { aggregateStage } = this.parent;
            if (Number(aggregateStage) !== 304 || Number(aggregateStage) !== 305) return true;

            const hasAtLeastOne = Object.values(value || {}).some(v => typeof v === 'string' && v.trim() !== '');
            return hasAtLeastOne;
        }),
    stage: yup
        .number()
        .nullable()
        .when(
            [
                'curricularOrganization',
                'typeServices',
                'aggregateStage'
            ],
            {
                is: (
                    curricularOrganization,
                    typeServices,
                    aggregateStage
                ) => {
                    const isBasicEducationYes = curricularOrganization && Number(curricularOrganization.basicGeneralFormation) === 1;
                    const isCurricularYes = typeServices && Number(typeServices.curricularStage) === 1;
                    const isAggregateStageValid = aggregateStage && [301, 302, 303, 306, 308].includes(aggregateStage);
                    console.log('dd',isBasicEducationYes, isCurricularYes);

                    return (isBasicEducationYes && isCurricularYes && isAggregateStageValid);
                },
                then: yup
                    .number()
                    .moreThan(0, 'Selecione pelo menos uma opção')
                    .typeError('Selecione pelo menos uma opção'),
            }
        ),

    multi: yup.number().when('stage', {
        is: (etapa) => {
            if (etapa === 3 || etapa === 22 || etapa === 23 || etapa === 72 || etapa === 56 || etapa === 64) {
                return true
            }
            return false
        },
        then: yup.number().moreThan(0, '  Selecione pelo menos uma opção').typeError("  Selecione pelo menos uma opção")
    }).nullable(),
    complementaryActivity: yup.array().when('typeServices', {
          is: (typeServices) => {
            if (typeServices?.specializedEducationalService === 1) {
                return true;
            }
            return false;
        },
        then: yup.array().required().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
            return validateObject2(value);
        })
    }).nullable(),
    formsOrganization: yup.array().when('stage', {
          is: (stage) => {
            if (Number(stage) > 3) {
                return true;
            }
            return false;
        },
        then: yup.array().required().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
            return validateObject(value);
        })
    }).nullable(),
    curricularComponents: yup.array().when('stage', {
        is: (stage) => {

            if ((Number(stage)) > 3) {
                return true;
            }
            return false;
        },
        then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
            return validateObject(value);
        })
    }).nullable(),
    codeCourse: yup.string().when('stage', {
        is: (stage) => {
            if ([39, 46, 54].includes(stage)) {
                return true;
            }
            return false;
        },
        then: yup.string().max(10, 'o código do curso deve ter no máximo 10 caracteres').required('informe o código do curso, este campo é obrigatório')
    }).nullable(),
    alternationFormation: yup.number().moreThan(-1, 'Selecione uma opção').typeError(' Selecione uma das opções'),

    formativeArea: yup.array().when('curricularOrganization.deepFormativeItinerary', {
        is: 1,
        then: yup.array()
            .min(1, 'Selecione pelo menos uma área formativa.')
            .required('Selecione pelo menos uma área formativa.'),
        otherwise: yup.array().nullable()
    }),
    typeCourseFormativeItinerary: yup.number().when('curricularOrganization.professionalFormativeItinerary', {
        is: 1,
        then: yup.number().moreThan(-1, 'Selecione uma opção').typeError(' Selecione uma das opções'),
        otherwise: yup.number().nullable()
    }),
    courseTechCode: yup.number().when('typeCourseFormativeItinerary', {
        is: 1,
        then: yup.number().moreThan(0, 'Informe o código do curso técnico').typeError('Informe o código do curso técnico'),
        otherwise: yup.number().nullable()
    }),
    bilingualEducationClassDeaf: yup.number().moreThan(-1, 'Selecione uma opção').typeError(' Selecione uma das opções'),
})

export function renderSelect(typeMediation,
    workingPlace,
    campo7Reg50,
    ActivityComplementar,
    aggregateStage,
    basicGeneralFormation,
    itinerary,
    codeCourse) {
    let opcoes = [];

    // Regras 5 e 6
    if (typeMediation === 2) {
        opcoes = [69, 70, 71, 72]; // Regra 5
    } else if (typeMediation === 3) {
        opcoes = [25, 26, 27, 28, 29, 35, 36, 37, 38, 39, 40, 70, 71, 64]; // Regra 6
    }

    // Regra 7
    if ([2, 3].includes(workingPlace)) {
        opcoes = opcoes.filter(o => ![1, 2, 3, 56].includes(o));
    }

    // Regra 9
    if (ActivityComplementar === 1) {
        opcoes = opcoes.filter(o => ![1, 2, 3, 39, 40, 56, 64, 69, 70, 71, 72].includes(o));
    }

    // Regras 10 a 16 — baseadas na etapa agregada
    switch (aggregateStage) {
        case 301:
            opcoes = [1, 2, 3];
            break;
        case 302:
            opcoes = [14, 15, 16, 17, 18, 19, 20, 21, 41];
            break;
        case 303:
            opcoes = [22, 23, 56];
            break;
        case 304:
            if (basicGeneralFormation === 1) {
                opcoes = [25, 26, 27, 28, 29];
            }
            break;
        case 305:
            if (basicGeneralFormation === 1) {
                opcoes = [35, 36, 37, 38];
            }
            break;
        case 306:
            opcoes = [69, 70, 72, 71, 74, 73, 67];
            break;
        case 308:
            opcoes = [39, 40, 64, 68];
            break;
        default:
            break;
    }

    return [...new Set(opcoes)].sort((a, b) => a - b);
}

export function renderSelectMulti(etapa) {
    let opcoes = opcoesMulti
    if (![3, 22, 23, 72, 56, 64].includes(etapa)) {
        return [];
    }

    if (etapa === 3) {
        return opcoes.filter(opcao => [1, 2].includes(opcao.value));
    }

    if (etapa === 22 || etapa === 23) {
        return opcoes.filter(opcao => [14, 15, 16, 17, 18, 19, 20, 21, 41].includes(opcao.value));
    }

    if (etapa === 72) {
        return opcoes.filter(opcao => [69, 70].includes(opcao.value));
    }

    if (etapa === 56) {
        return opcoes.filter(opcao => [1, 2, 14, 15, 16, 17, 18, 19, 20, 21, 41].includes(opcao.value));
    }

    if (etapa === 64) {
        return opcoes.filter(opcao => [39, 40].includes(opcao.value));
    }

    return opcoes;
}



